import Backbone from "backbone";
import * as _ from "underscore";

import SelectionModel from "models/SelectionModel";
import UserWordModel from "models/UserWordModel";
import readlangClient from "readlangClient";

const RemoteUserWordsCollection = Backbone.Collection.extend({
  model: UserWordModel,
  url: "/api/v2/userWords",
  initialize: function (models, options) {
    const that = this;

    this.options = options || {};
    const SearchQueryModel = Backbone.Model.extend({
      defaults: {
        from: 0,
        limit: 25,
        contexts: true,
        sortBy: "lastModified",
      },
    });
    this.searchQuery = new SearchQueryModel();
    this.searchQuery.on("change", (model, innerOptions) => {
      if (innerOptions.settingDeletedDate) {
        return;
      }
      that.selectionModel.clearSelection();

      if (that.searchQuery.get("wordGroup") === "deleted") {
        that.searchQuery.set("sortBy", "deletedDate", {
          settingDeletedDate: true,
        });
      }

      that.reFetch();
    });

    this.searchQuery.on("change:sortBy", () => {
      that.searchQuery.set("from", 0);
    });

    this.selectionModel = new SelectionModel({ collection: this });

    this.on("add", () => {
      that.totalCount++;
    });
    this.on("remove", () => {
      that.totalCount--;
    });

    this.allPhraseIndex = {};
  },
  performAction: function (action, selectionModel) {
    const that = this;
    let selectedModels;

    if (selectionModel.get("wholeCollection")) {
      selectedModels = this.models;
    } else {
      selectedModels = _.map(selectionModel.get("itemIDs"), (userWordID) =>
        that.get(userWordID)
      );
    }

    switch (action) {
      case "delete":
        readlangClient.request(
          "DELETE",
          "/api/userWords",
          selectionModel.getQuery(),
          (response) => {
            that.remove(selectedModels);
            that.selectionModel.clearSelection();
            that.trigger("wordsDeleted", response);
          }
        );
        break;
      case "undelete":
        readlangClient.request(
          "PATCH",
          "/api/userWords/unDelete",
          selectionModel.getQuery(),
          () => {
            that.remove(selectedModels);
            that.selectionModel.clearSelection();
          }
        );
        break;
      case "permDelete": {
        const wordCount = selectionModel.get("count");
        let countString;
        if (wordCount === 1) {
          countString = "this word";
        } else {
          countString = "these " + wordCount + " words";
        }
        if (
          confirm(
            "Are you sure you want to PERMANENTLY DELETE " +
              countString +
              ". " +
              "No way to undo!"
          )
        ) {
          readlangClient.request(
            "DELETE",
            "/api/userWords",
            _.extend(selectionModel.getQuery(), { permanent: true }),
            () => {
              that.remove(selectedModels);
              that.selectionModel.clearSelection();
              //that.trigger('wordsDeleted', response);
            }
          );
        }
        break;
      }

      default:
        console.error("action not recognised: ", action);
    }
  },
  fetchNext: function (params) {
    this.options.suppressFetch = true;
    this.searchQuery.set(
      "from",
      Math.min(this.searchQuery.get("from") + this.length, this.totalCount)
    );
    this.options.suppressFetch = false;
    this.reFetch(params);
  },
  fetchPrev: function (params) {
    this.options.suppressFetch = true;
    this.searchQuery.set(
      "from",
      Math.max(0, this.searchQuery.get("from") - this.searchQuery.get("limit"))
    );
    this.options.suppressFetch = false;
    this.reFetch(params);
  },
  fetch: function (params) {
    params = params || {};
    this.options.suppressFetch = true;
    this.searchQuery.clear().set(this.searchQuery.defaults).set(params.data);
    this.options.suppressFetch = false;

    this.reFetch(params);
  },
  reFetch: function (params) {
    if (this.options.suppressFetch) {
      return;
    }
    params = params || {};

    readlangClient.request(
      "GET",
      this.url,
      _.extend(this.searchQuery.toJSON(), {
        language: this.options.user.get("currentLearningLanguage"),
      }),
      (result) => {
        this.totalCount = result.count;
        this.reset(result.userWords);

        if (params.success) {
          params.success(null, result);
        }
      }
    );
  },
});

export default RemoteUserWordsCollection;
